export enum Permissions {
    WRITE_ADMIN = 'User Admin',
    EA_USER = 'Early Availability',
    SH_V2 = 'SH V2',
    CUSTOM_SIGNALS = 'Custom Signals',
}
